import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-ddt-history',
  template: `<app-ddt-history-table [ddtId]="ddtID"></app-ddt-history-table>`,
})
export class ModalDdtHistoryComponent {
  ddtID?: number;

  constructor(public config: DynamicDialogConfig) {
    this.ddtID = config.data.ddt_id;
  }
}
